// Keep track of wrapped listeners so remove() actually detaches them.
const listeners = {};

const eventBus = {
	on(event, callback) {
		const handler = (e) => callback(e.detail);
		(listeners[event] = listeners[event] || []).push({ callback, handler });
		document.addEventListener(event, handler);
	},
	dispatch(event, data) {
		document.dispatchEvent(new CustomEvent(event, { detail: data }));
	},
	remove(event, callback) {
		const list = listeners[event] || [];
		listeners[event] = list.filter((l) => {
			if (!callback || l.callback === callback) {
				document.removeEventListener(event, l.handler);
				return false;
			}
			return true;
		});
	},
};

export default eventBus;
